import { mobilePxString, tabletPxString, desktopPxString, largeDesktopPxString } from '../constants/Breakpoints';

interface BreakpointDeclarations {
    mobile?: string;
    tablet?: string;
    desktop?: string;
    largeDesktop?: string;
}

const breakpoints: string[] & BreakpointDeclarations = [
    mobilePxString,
    tabletPxString,
    desktopPxString,
    largeDesktopPxString,
];

// breakpoints aliases
breakpoints.mobile = breakpoints[0];
breakpoints.tablet = breakpoints[1];
breakpoints.desktop = breakpoints[2];
breakpoints.largeDesktop = breakpoints[3];

export const DefaultTheme = {
    breakpoints,
};
